import { exhaustiveFail } from '@cbridge-utils/error';
import { IApiScheduleInterval, ApiScheduleIntervalType } from '@cbridge-packages/api';
import { ISchedule } from '@cbridge-packages/schedule';
import { makeIntervalId } from './_helpers/scheduleIntervalId';
import { timeOfTheDay } from './_helpers/timeOfTheDay';
import { IScheduleInterval, IScheduleIntervalForm, ScheduleIntervalType } from './scheduleInterval.interface';
import { DAYJS_DATE_STUB } from './scheduleInterval.constant';

export namespace ScheduleIntervalTranslator {
  export function fromApi(scheduleId: ISchedule['scheduleId'], index: number, interval: IApiScheduleInterval): IScheduleInterval {
    return {
      intervalId: makeIntervalId(scheduleId, index),
      startDayOfWeek: interval.startDayOfWeek,
      startTime: interval.startTime,
      endDayOfWeek: interval.endDayOfWeek,
      endTime: interval.endTime,
      type: fromApiIntervalType(interval.type),
    };
  }

  export function toApi(interval: IScheduleInterval): IApiScheduleInterval {
    return {
      startDayOfWeek: interval.startDayOfWeek,
      startTime: interval.startTime,
      endDayOfWeek: interval.endDayOfWeek,
      endTime: interval.endTime,
      type: toApiIntervalType(interval.type),
    };
  }

  export function formToApi(interval: IScheduleIntervalForm): IApiScheduleInterval {
    return {
      startDayOfWeek: interval.startDayOfWeek,
      startTime: timeOfTheDay(interval.startTime),
      endDayOfWeek: interval.endDayOfWeek,
      endTime: timeOfTheDay(interval.endTime),
      type: toApiIntervalType(interval.type),
    };
  }

  export function toFormData(interval: IScheduleInterval): IScheduleIntervalForm {
    if (!interval) {
      return undefined;
    }

    return {
      intervalId: interval.intervalId,
      startDayOfWeek: interval.startDayOfWeek,
      startTime: DAYJS_DATE_STUB.second(interval.startTime),
      endDayOfWeek: interval.endDayOfWeek,
      endTime: DAYJS_DATE_STUB.second(interval.endTime),
      type: interval.type,
    };
  }

  export function fromApiIntervalType(type: ApiScheduleIntervalType): ScheduleIntervalType {
    switch (type) {
      case ApiScheduleIntervalType.Pricing:
        return ScheduleIntervalType.Pricing;
      case ApiScheduleIntervalType.Trading:
        return ScheduleIntervalType.Trading;
      case ApiScheduleIntervalType.PricingAndTrading:
        return ScheduleIntervalType.Both;
      default:
        return exhaustiveFail(type);
    }
  }

  export function toApiIntervalType(type: ScheduleIntervalType): ApiScheduleIntervalType {
    switch (type) {
      case ScheduleIntervalType.Pricing:
        return ApiScheduleIntervalType.Pricing;
      case ScheduleIntervalType.Trading:
        return ApiScheduleIntervalType.Trading;
      case ScheduleIntervalType.Both:
        return ApiScheduleIntervalType.PricingAndTrading;
      default:
        return exhaustiveFail(type);
    }
  }
}
